export var RESULTS_INCREMENT = 5;
export var DEFAULT_TLD = '.com';